import { DVMNodes } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { SblibService } from '../../../services/sblib.service';
import { ToolsService } from '../../services/tools.service';
import { ColormapTemplate, default_colors } from '../models/default.model';

@Component({
  selector: 'app-colormap-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
})
export class TemplatesComponent implements OnInit {
  public subscriptions: Array<Subscription>;
  public templates: Array<ColormapTemplate> = [];
  public editMode: ColormapTemplate = null;
  public editMasterColors: default_colors = null;
  private appliedTemplate: any = null;
  @Output() doApplyTemplate = new EventEmitter<ColormapTemplate>();
  @Output() doUpdateTemplatesList = new EventEmitter<Array<ColormapTemplate>>();

  constructor(
    private apiService: SbApiService,
    private route: ActivatedRoute,
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    console.log(this.route.snapshot.data);
    if (this.route.snapshot.data.dataFlow.workflow.template_maps) {
      this.templates = this.route.snapshot.data.dataFlow.workflow.template_maps;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public editTemplate(template) {
    this.editMode = JSON.parse(JSON.stringify(template));
    this.editMasterColors = {
      already_loaded: {
        section: false,
        seat: false,
        areaprice: false,
      },
      styles: [],
    };
    if (this.editMode.values.section) {
      let style = {
        title: 'section',
        styles: JSON.parse(JSON.stringify(this.editMode.values.section)),
      };
      this.editMasterColors.styles.push(style);
    }
    if (this.editMode.values.seat) {
      let style = {
        title: 'seat',
        styles: JSON.parse(JSON.stringify(this.editMode.values.seat)),
      };
      this.editMasterColors.styles.push(style);
    }
  }

  public onDestroyTemplate() {
    const u$ = this.apiService.deleteTemplateColormap(this.editMode.id).subscribe(res => {
      this.templates = this.templates.filter(i => {
        return i.id !== this.editMode.id;
      });
      this.editMode = null;
      this.doUpdateTemplatesList.emit(this.templates);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(u$);
  }

  public onUpdatedTemplate(template: DVMNodes) {
    this.templates = this.templates.map(i => {
      if (i.id === this.editMode.id) {
        i.name = this.editMode.name;
        i.values = Object.assign({}, template);
      }
      return i;
    });

    const body = {
      name: this.editMode.name,
      workflow_id: this.route.snapshot.data.dataFlow.workflow.id,
      values: JSON.stringify(template),
    };

    const u$ = this.apiService.updateTemplateColormap(this.editMode.id, body).subscribe(res => {
      this.editMode = null;
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(u$);
  }

  public applyTemplate(template) {
    this.appliedTemplate = template;
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.colormap.default = false;
      res.colormap.manual = JSON.parse(JSON.stringify(template.values));
      this.sblibService.apply(res);
      this.doApplyTemplate.emit(template);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

  public getTool() {
    const tool = {
      default: false,
      manual: JSON.parse(JSON.stringify(this.appliedTemplate.values)),
    };
    return tool;
  }
}
